import { useRouter } from 'vue-router';

import type { Takeaway } from '~/models';

interface State {
  comment: string;
  takeawayType: Takeaway['type'];
}

const state = reactive<State>({
  comment: '',
  takeawayType: 'Delivery'
});

const useCart = () => {
  const router = useRouter();
  const cartStore = useCartStore();
  const preferenceStore = usePreferenceStore();

  state.comment = cartStore.comment;
  state.takeawayType = !preferenceStore.inDeliveryTime
    ? 'Collection'
    : cartStore.takeaway.type;

  const isCheckoutDisabled = computed<boolean>(() => {
    if (!preferenceStore.isRestaurantOpened) {
      return true;
    }

    if (
      !preferenceStore.preference.general.enableCollection &&
      !preferenceStore.inDeliveryTime
    ) {
      return true;
    }

    return cartStore.items.length === 0;
  });

  const checkMinimumDelivery = (takeawayType: Takeaway['type']): void => {
    const minimumDeliveryOrder =
      preferenceStore.preference.general.minimumDeliveryOrder || 0;

    if (
      takeawayType === 'Delivery' &&
      cartStore.subtotal < minimumDeliveryOrder
    ) {
      throw new Error(
        `The minimum value for delivery is ${
          preferenceStore.moneySymbol
        } ${minimumDeliveryOrder.toFixed(2)}`
      );
    }
  };

  const goToCheckout = async (): Promise<void> => {
    checkMinimumDelivery(state.takeawayType);

    cartStore.setComment(state.comment);
    await cartStore.setTakeawayType(state.takeawayType);

    await router.push({ name: 'checkout-takeaway' });
  };

  return {
    state,
    isCheckoutDisabled,
    goToCheckout
  };
};

export { useCart };
